export default __webpack_public_path__ + "static/media/element_63.8fa0f8e7.webp";